import { motion } from 'framer-motion';
import { Building2, Award, Users, Target } from 'lucide-react';

export function About() {
  const values = [
    { icon: Target, title: '诚信', description: '以诚信为本，建立长期合作关系' },
    { icon: Users, title: '合作', description: '携手共进，实现共同发展' },
    { icon: Award, title: '共赢', description: '创造价值，实现多方共赢' },
    { icon: Building2, title: '品质', description: '追求卓越，提供优质服务' },
  ];

  return (
    <section id="about" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <div className="inline-block px-4 py-1 rounded-full bg-orange-50 text-orange-600 text-sm mb-4">
            关于我们
          </div>
          <h2 className="text-gray-900 mb-4 px-4">企业简介</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 mx-auto"></div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-16">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-6"
          >
            <div className="space-y-4">
              <p className="text-gray-700 leading-relaxed">
                <span className="text-orange-600">越亘科技（YUEGEEN TECHNOLOGY）</span>
                成立于2014年，是一家专注于企业数字化转型与全球化服务的国家级高新技术企业。
              </p>
              <p className="text-gray-700 leading-relaxed">
                由深耕行业近20年的管理咨询及信息化专家团队创立，公司以<span className="text-orange-600">"诚信、合作、共赢、品质"</span>为核心价值观，致力于成为最受尊敬的现代化服务企业。
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4 pt-6">
              <div className="p-4 rounded-xl bg-gradient-to-br from-orange-50 to-yellow-50">
                <div className="text-2xl text-orange-600 mb-1">500+</div>
                <div className="text-gray-600 text-sm">服务企业客户</div>
              </div>
              <div className="p-4 rounded-xl bg-gradient-to-br from-red-50 to-orange-50">
                <div className="text-2xl text-red-600 mb-1">10</div>
                <div className="text-gray-600 text-sm">城市战略布局</div>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjB0ZWFtJTIwd29ya2luZ3xlbnwxfHx8fDE3NjU0NDY2MjB8MA&ixlib=rb-4.1.0&q=80&w=1080"
                alt="团队协作"
                className="w-full h-[300px] sm:h-[400px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-orange-600/20 to-yellow-600/20"></div>
            </div>

            {/* Floating Card */}
            <div className="absolute -bottom-4 -right-4 sm:-bottom-6 sm:-right-6 bg-white rounded-xl shadow-xl p-4 sm:p-6 max-w-[160px] sm:max-w-xs">
              <div className="text-3xl sm:text-4xl text-orange-600 mb-2">2014</div>
              <div className="text-gray-600 text-sm">成立至今，深耕行业近20年</div>
            </div>
          </motion.div>
        </div>

        {/* Core Values */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h3 className="text-center text-gray-900 mb-8">核心价值观</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group p-6 rounded-xl bg-white border border-gray-200 hover:border-orange-300 hover:shadow-xl transition-all"
              >
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-yellow-500 via-orange-500 to-red-500 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <value.icon className="text-white" size={24} />
                </div>
                <h4 className="text-gray-900 mb-2">{value.title}</h4>
                <p className="text-gray-600 text-sm">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
